import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { Category } from "src/app/backend/models/tag/tag";
import { ReportDesignerItemCustom } from "src/app/modules/bootstrap/modules/report/report-design-item";
import { buildTagsDataSource } from "src/app/support/datasources/tags.datasource";
import { TagBackend } from "src/app/backend/api/tag/tag.backend";
import { dxTagBox } from "src/app/support/dx-tag-box";
import { CreateTagFunctionService } from "src/app/modules/bootstrap/pms-ui/functions/tag/create-tag/create-tag-function.service";

@Component({
  selector: "pms-soap-template-diagnosis",
  templateUrl: "soap-template-diagnosis.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class SoapTemplateDiagnosisComponent {
  action$: EventEmitter<string> = new EventEmitter<string>();

  @Input()
  readOnly: boolean = false;

  @Output()
  data: EventEmitter<{ tags: string[] }> = new EventEmitter();

  private readonly tagBackend = inject(TagBackend);
  private readonly createTagFunctionService = inject(CreateTagFunctionService);

  dxTagOrgans = dxTagBox(
    {
      dxTagsDataSource: buildTagsDataSource(
        {
          tagsBackend: this.tagBackend
        },
        {
          disableCreateTag: false,
          category: Category.DIAGNOSIS
        }
      )
    },
    {
      createTagFunctionService: this.createTagFunctionService
    },
    {
      disableRemoveButton: false
    }
  );

  set item(value: ReportDesignerItemCustom) {
    this.preview = !!value.config.preview;
    this.tags = value.config?.tags || [];
  }

  @Input()
  preview: boolean = false;

  @Input()
  tags: string[] = [];

  onTagsUpdated(tags: string[]): void {
    this.data.emit({
      tags: tags
    });
    this.tags = tags;
  }
}
